// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__C5A4b","footer":"ModalInfo_footer__2r1t9"};